import RichTextReader from "../Atoms/RichTextReader";

type Props = {
  text: any;
  setTerms: (id: string) => void;
};

/**
   @function section
   render one paragraph of text with its references
   @param text {array} - section to render
   @param setTerms {function} - function to set terms 
*/
export default function Section({ text, setTerms }: Props) {
  return <RichTextReader text={text} size="0.8rem" setTerms={setTerms} />;
}
